import React from 'react';
import {
  LinkIcon,
  ShoppingBagIcon,
  HomeIcon,
  CreditCardIcon,
  UserGroupIcon,
  ArchiveBoxIcon,
  ClipboardDocumentListIcon,
  BuildingOffice2Icon,
  ChartBarIcon,
  PaintBrushIcon,
  Cog6ToothIcon,
  SwatchIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

export const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: <HomeIcon /> },
  { name: 'Links', href: '/dashboard/links', icon: <LinkIcon /> },
  {
    name: 'Statistiken',
    href: '/dashboard/statistiken',
    icon: <ChartBarIcon />,
  },
  {
    name: 'Kartenverwaltung',
    href: '/dashboard/kartenverwaltung',
    icon: <CreditCardIcon />,
  },
  {
    name: 'Bestellungen',
    href: '/dashboard/bestellungen',
    icon: <ShoppingBagIcon />,
  },
];

export const adminNavigation = [
  ...navigation,
  {
    name: 'Bestellbearbeitung',
    href: '/dashboard/bestellbearbeitung',
    icon: <ArchiveBoxIcon />,
  },
  {
    name: 'Benutzerverwaltung',
    href: '/dashboard/benutzerverwaltung',
    icon: <UserGroupIcon />,
  },
  {
    name: 'Kartenadministration',
    href: '/dashboard/kartenadministration',
    icon: <CreditCardIcon />,
  },
  {
    name: 'Firmenverwaltung',
    href: '/dashboard/firmenverwaltung',
    icon: <BuildingOffice2Icon />,
  },
  {
    name: 'Audit-Log',
    href: '/dashboard/protokoll',
    icon: <ShieldCheckIcon />,
  },
];

export const companyAdminNavigation = [
  {
    name: 'Mitarbeiter',
    href: '/dashboard/firma/mitarbeiter',
    icon: <UserGroupIcon />,
  },
  {
    name: 'Statistiken',
    href: '/dashboard/firma/statistiken',
    icon: <ChartBarIcon />,
  },
  {
    name: 'Kartendesigns',
    href: '/dashboard/firma/kartendesigns',
    icon: <SwatchIcon />,
  },
  {
    name: 'Bestellungen',
    href: '/dashboard/firma/bestellungen',
    icon: <ShoppingBagIcon />,
  },
  {
    name: 'Karten',
    href: '/dashboard/firma/karten',
    icon: <CreditCardIcon />,
  },
  {
    name: 'Branding',
    href: '/dashboard/firma/branding',
    icon: <PaintBrushIcon />,
  },
  {
    name: 'Abonnement',
    href: '/dashboard/firma/abonnement',
    icon: <ClipboardDocumentListIcon />,
  },
  {
    name: 'Firmeneinstellungen',
    href: '/dashboard/firma/einstellungen',
    icon: <Cog6ToothIcon />,
  },
];
